/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Box, Grid, TextField, IconButton } from '@mui/material';
import { Close, Add } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CustomTextField } from '../../index';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ContainedButton } from '../../index';
import { useState } from 'react';

export const VoluntaryWorksTab = (props) => {
  const handleChange = (index, field, value) => {
    props.setVolWork((prev) => {
      const updated = [...prev];

      if (field === 'hours') {
        const parsed = value === '' ? undefined : parseFloat(value);
        updated[index] = { ...updated[index], [field]: parsed };
      } else {
        updated[index] = { ...updated[index], [field]: value };
      }

      return updated;
    });
  };

  const handleAdd = () => {
    props.setVolWork((prev) => [
      {
        empid: props.empid,
        organizationname: '',
        address: '',
        startdate: undefined,
        enddate: undefined,
        hours: undefined,
        position: '',
      },
      ...prev,
    ]);
  };

  const handleDelete = (index) => {
    props.setVolWork((prev) => prev.filter((_, i) => i !== index));
  };

  const boxStyle = {
    mx: 0,
    my: 1,
    px: 3,
    py: 2,
  };
  const [startTouched, setStartTouched] = useState(false);

  return (
    <Box sx={{ ...boxStyle, maxHeight: '400px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        {!props.viewOnly && (
          <ContainedButton
            startIcon={<Add />}
            onClick={handleAdd}
            variant="contained"
            btnTitle={'Add Voluntary Work'}
            style={{ width: 'auto' }}
          />
        )}
      </Box>
      {props.empVolWork.map((work, index) => (
        <Box
          key={index}
          sx={{
            bgcolor: 'rgb(26, 32, 44, 0.6)',
            display: 'flex',
            justifyContent: 'start',
            p: 2,
            mt: 2,
            borderRadius: '5px',
            position: 'relative',
          }}
        >
          {!props.viewOnly && (
            <IconButton
              aria-label="delete"
              onClick={() => handleDelete(index)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                mr: 1,
              }}
            >
              <Close />
            </IconButton>
          )}
          <Grid container columnSpacing={2} sx={{ mt: 3 }}>
            <Grid item xs={6}>
              <CustomTextField
                error={!work.organizationname}
                errorMsg="Please enter an organization name"
                label="Name of Organization"
                value={work.organizationname || ''}
                onChange={(e) =>
                  handleChange(index, 'organizationname', e.target.value)
                }
                viewOnly={props.viewOnly}
                required
              />
            </Grid>

            <Grid item xs={6}>
              <CustomTextField
                errorMsg="Please enter an address"
                label="Address"
                value={work.address || ''}
                onChange={(e) => handleChange(index, 'address', e.target.value)}
                viewOnly={props.viewOnly}
              />
            </Grid>

            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Start Date"
                  value={work.startdate ? new Date(work.startdate) : null}
                  maxDate={work.enddate ? new Date(work.enddate) : undefined}
                  onChange={(newValue) =>
                    handleChange(index, 'startdate', newValue)
                  }
                  disableOpenPicker={props.viewOnly}
                  readOnly={props.viewOnly}
                  renderInput={(params) => {
                    const showError = startTouched && !work.startdate;
                    return (
                      <TextField
                        onFocus={() => setStartTouched(true)}
                        margin="normal"
                        fullWidth
                        required
                        {...params}
                        error={showError}
                        helperText={showError ? 'Start Date is required' : ''}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            cursor: props.viewOnly ? 'default' : undefined,
                          },
                        }}
                      />
                    );
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="End Date"
                  value={work.enddate ? new Date(work.enddate) : null}
                  minDate={
                    work.startdate ? new Date(work.startdate) : undefined
                  }
                  onChange={(newValue) =>
                    handleChange(index, 'enddate', newValue)
                  }
                  disableOpenPicker={props.viewOnly}
                  readOnly={props.viewOnly}
                  renderInput={(params) => (
                    <TextField
                      margin="normal"
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          cursor: props.viewOnly ? 'default' : undefined,
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6}>
              <CustomTextField
                type="number"
                errorMsg="Please enter number of hours"
                label="Number of Hours"
                value={work.hours || ''}
                onChange={(e) => handleChange(index, 'hours', e.target.value)}
                viewOnly={props.viewOnly}
              />
            </Grid>

            <Grid item xs={6}>
              <CustomTextField
                errorMsg="Please enter a position"
                label="Position"
                value={work.position || ''}
                onChange={(e) =>
                  handleChange(index, 'position', e.target.value)
                }
                viewOnly={props.viewOnly}
              />
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};
